import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import * as actions from '../../actions';
import { conditionallyRequiredEmailSignup, isRequiredSelectionCheckbox, conditionallyRequiredSelection } from '../helpers/Validation';

class step7 extends Component {
    render() {
        const { emailAddress, agreeToTerms } = this.props.questionOptions; 
        return (
            <Fragment>
                <div className="grid offer-signup">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <p>You've completed your Symptom Discussion Guide. If you'd like to receive a copy of your completed guide, please provide your email:</p>                            
                            <div className="row">
                                <div className="col-lg-10 offset-lg-1">
                                    <div className="form-group relative ddg-end">
                                        <Field
                                            name="emailAddress"
                                            component="input"
                                            validate={conditionallyRequiredEmailSignup((emailAddress || agreeToTerms) ? 1 : 0, this.props.bypassValidation)}
                                            key={"email" + (emailAddress || agreeToTerms ? 1 : 0)}
                                            disabled={this.props.bypassValidation}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <label className="text-left full-width full-width-input signup-label">Email</label>
                                                    <input {...input} id="emailAddress" className="emailAddress form-control full-width-input signup-input" type="text" placeholder="Example: name@email.com" />
                                                    {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="emailAddress">
                                            {(value, previous) => {
                                                this.props.questionAnswer("emailAddress", value);
                                            }}
                                        </OnChange>
                                    </div>
                                    <div className="form-group relative">
                                        <label className="inline-checkboxes tos">                            
                                        <Field
                                                name="agreeToTerms"
                                                component="input"
                                                type="checkbox"
                                                validate={conditionallyRequiredSelection(this.props.bypassValidation)}
                                                disabled={this.props.bypassValidation}
                                               //validate={conditionallyRequiredEmailSignup(emailAddress || agreeToTerms ? 1 : 0)}
                                               // key={"tos" + (emailAddress || agreeToTerms ? 1 : 0)}
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input {...input}  id="agreeToTerms" class="agreeToTerms" value={input.value} checked={input.checked} />
                                                        By checking this box, I understand and agree to the <a href="https://www.acadia-pharm.com/privacy/" className="signup-terms-and-privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.acadia-pharm.com/terms/" className="signup-terms-and-privacy" target="_blank" rel="noopener noreferrer">Terms of Use</a>.<br/>
                                                        {meta.error && meta.touched && meta.error }
                                                    </Fragment>
                                                )}
                                            </Field> {' '}
                                            <span></span>
                                            
                                           
                                        </label>
                                        <OnChange name="agreeToTerms">
                                            {(value, previous) => {
                                                this.props.questionAnswer("agreeToTerms", value);
                                            }}
                                        </OnChange>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(step7);